var _defs, _clipPath, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.5,
    height: 20.5,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M44.5 20H24v8.5h11.8C34.7 33.9 30.1 37 24 37c-7.2 0-13-5.8-13-13s5.8-13 13-13c3.1 0 5.9 1.1 8.1 2.9l6.4-6.4C34.6 4.1 29.6 2 24 2 11.8 2 2 11.8 2 24s9.8 22 22 22c11 0 21-8 21-22 0-1.3-.2-2.7-.5-4z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    overflow: "visible"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "#FBBC05",
    d: "M0 37V11l17 13z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "#EA4335",
    d: "M0 11l17 13 7-6.1L48 14V0H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "#34A853",
    d: "M0 37l30-23 7.9 1L48 0v48H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "#4285F4",
    d: "M48 48L17 24l-4-3 35-10z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google-logo.019e975f0bdc6fd721af72e1a949ea7a.svg";
export { ForwardRef as ReactComponent };